import type { PlanDraft, DryRunResponse } from '../../pages/documents/CapturePhotoPage.js';
import { sourceLineForPlan } from './planLineSource.js';
import { isTrustedDocumentMatch } from './documentMatchTrust.js';
import { normalizeUom } from '../uom.js';

export function applyRefreshedMatches(current: PlanDraft, refreshed: DryRunResponse): PlanDraft {
  return { ...current, supplier_id: current.supplier_id ?? refreshed.supplier?.existing?.id ?? null, lines: current.lines.map((line, index) => {
    if (line.food_id || line.skip || line.new_food_confirmed) return line;
    const source = sourceLineForPlan(refreshed.lines, line, index);
    const food = source?.food_match;
    // Never change confirmed quantities/units as a side effect of refreshing identity.
    if (!food || !isTrustedDocumentMatch(source?.match_source) || normalizeUom(food.default_uom) !== normalizeUom(line.uom)) return line;
    return { ...line, food_id: food.id, keep_current_lot: source?.default_keep_current_lot ?? line.keep_current_lot };
  }) };
}


type DryRunLine = DryRunResponse['lines'][number];
export type RefreshedLineMatch = Pick<DryRunLine, 'food_match' | 'match_source' | 'alias_meta' | 'similar_food' | 'similar_foods' | 'identity_candidates'>;
export function mergeRefreshedLineMatches(current: DryRunResponse, matches: RefreshedLineMatch[]): DryRunLine[] {
  if (!Array.isArray(matches) || matches.length !== current.lines.length) throw new Error('document_rematch_failed');
  return current.lines.map((line, index) => {
    const match = matches[index];
    const food = match.food_match as (NonNullable<DryRunLine['food_match']> & { current_lot_document_date?: string | null }) | null;
    const previousDate = food?.current_lot_document_date;
    const older = !!previousDate && !!current.document.date && current.document.date <= previousDate;
    return { ...line, ...match, index: line.index,
      current_lot: food?.current_batch_lot ? { batch_lot: food.current_batch_lot, document_date: previousDate ?? null } : null,
      default_keep_current_lot: older,
      lot_date_comparison: previousDate && current.document.date ? older ? 'older_or_equal' : 'newer' : 'unknown' };
  });
}
